import React, {
  Fragment, useState, useEffect, useRef
} from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import moment from 'moment'
import NavBar from '../../../components/NavBar'
import UserHeader from '../Headers/UserHeader'
// import ManagementContent from './usermanagement'
import UserManagementContent from './UserManagement'

function UserManagement (props) {
  const content = useRef()
  const [searchText, setSearchText] = useState('')
  const [openPicker, setOpenPicker] = useState(false)
  const [initialFlag, setinitialFlag] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  useEffect(() => {
    const obj = qs.parse(props.location.search)

    setSearchText(obj.search || '')
    if (obj.startDate && obj.endDate) {
      setStartDate(obj.startDate)
      setEndDate(obj.endDate)
    }
  }, [])

  function onHandleSearch (e) {
    setSearchText(e.target.value)
    setinitialFlag(true)
  }

  function handleKeyPress (e) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  function onHandleDateRangePicker (isOpen = true, sd, ed) {
    setOpenPicker(isOpen)
    if (sd && ed) {
      setStartDate(moment(sd).format('DD MMM YYYY'))
      setEndDate(moment(ed).format('DD MMM YYYY'))
    } else {
      setStartDate('')
      setEndDate('')
    }
  }

  function onExport () {
    content.current.onExport()
  }
  return (
    <Fragment>
      <NavBar {...props} />
      <main className="main-content">
        <section className="management-section common-box">
          <UserHeader
          handleSearch={onHandleSearch}
          search={searchText}
          startDate={startDate}
          endDate={endDate}
          handleDateRangePicker={onHandleDateRangePicker}
          onExport={onExport}
          handleKeyPress={handleKeyPress}
          title="User Management" />

          <UserManagementContent
          ref={content}
          openPicker={openPicker}
          search={searchText}
          handleDateRangePicker={onHandleDateRangePicker}
          startDate={startDate}
          endDate={endDate}
          flag={initialFlag}
          {...props} />
        </section>
      </main>
    </Fragment>
  )
}

UserManagement.propTypes = {
  location: PropTypes.object,
  search: PropTypes.string
}
export default UserManagement
